import { Title, Text } from "@mantine/core";

export function RetailersPage() {
  return (
    <>
      <Title order={2} mb="md">
        Retailers
      </Title>
      <Text c="dimmed">Retailer management and scrape health monitoring.</Text>
    </>
  );
}
